export const PROCESSING_ROUTES = [
  {
    name: 'hesab-payment',
    path: '/hesab/payment',
    component: 'app/modules/processing/ui/pages/hesab-payment.vue',
  },
  {
    name: 'epoint-payment',
    path: '/epoint/payment',
    component: 'app/modules/processing/ui/pages/epoint-payment.vue',
  },
  {
    name: 'payment-accepted',
    path: '/payment/accepted',
    component: 'app/modules/processing/ui/pages/accepted.vue',
  },
  {
    name: 'payment-rejected',
    path: '/payment/rejected',
    component: 'app/modules/processing/ui/pages/rejected.vue',
  },
];

export const PROCESSING_ROUTE_PATH = Object.freeze({
  HESAB_PAYMENT: 'hesab-payment',
  EPOINT_PAYMENT: 'epoint-payment',
  PAYMENT_ACCEPTED: 'payment-accepted',
});
